import { render, staticRenderFns } from "./TelephonePlus.vue?vue&type=template&id=28fcfdd5"
import script from "./TelephonePlus.vue?vue&type=script&lang=js"
export * from "./TelephonePlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports